import { MatDialog } from "@angular/material/dialog";
import { NotificationAction } from "../model/notification.model";
import { Injectable } from '@angular/core';
import { HealthAnalysisDetailComponent } from "../../health-analysis/journey/component/detail/health-analysis-detail.component";
import { HealthAnalysisService } from "../../health-analysis/health-analysis.service";
import { Router } from "@angular/router";
import { OpenInternalLinkAction } from "../model/actions/open-internal-link.model";

@Injectable({ providedIn: 'root' })
export class NotificationActionHelper {
    constructor(
        private dialog: MatDialog,
        private healthAnalysisService: HealthAnalysisService,
        private router: Router
    ) {}

    handle(action: NotificationAction) {
        if (action.type === 'openLinkExternal') {
            window.open(action.url, '_blank')
        } else if (action.type === 'openLinkInternal') {
            this.handleInternalLinks(action);
        }
    }

    private handleInternalLinks(action: OpenInternalLinkAction) {
        const entityTypeMapper: Record<string, (action: OpenInternalLinkAction) => void> = {
           'healthAnalysis': (action) =>  this.handleHealthAnalysisEntity(action.entityValue),
           'healthAnalysis-result': (action) =>  this.handleHealthAnalysisResultEntity(action.entityValue),
        }

        entityTypeMapper[action.entityType](action);
    }
    private handleHealthAnalysisEntity(analysisIdentifier: string) {
        this.healthAnalysisService.getHealthAnalysisByAnalysisIdentifier(analysisIdentifier).subscribe(res => {
            this.dialog.open(HealthAnalysisDetailComponent, { data: res });
        })
    }
    private handleHealthAnalysisResultEntity(analysisIdentifier: string) {
        this.router.navigate(['health/analysis/journey'], { queryParams: { analysisIdentifier }});
    }
}
